<style scoped>

  @media only screen and (min-width: 991px) {
    .inline.fields {
      margin-top: -15px !important;
    }
  }

</style>

<template>
  
  <div :id="_uid" class="ui large modal" :class="modalSelector">

    <div class="ui header">
      Selecionar Usuários
    </div>

    <div class="content modal-content-scrolling">

      <div class="ui form" :class="{ loading }">

        <div class="fields">
          <div class="sixteen wide field">
            <label class="form-label">Perfis</label> 
          </div> 
        </div>
        <div class="inline fields">            
          <div class="field">
            <div class="ui checkbox user-picker-multiple-form-checkbox">
              <input type="checkbox" :value="true" v-model="profiles.employee">
              <label><user-group-icon group="employee" /> Colaboradores</label>
            </div>
          </div>
          <div class="field">
            <div class="ui checkbox user-picker-multiple-form-checkbox m-l-10">
              <input type="checkbox" :value="true" v-model="profiles.customer">
              <label><user-group-icon group="customer" /> Clínicas</label>
            </div>
          </div>
          <div class="field">
            <div class="ui checkbox user-picker-multiple-form-checkbox m-l-10">
              <input type="checkbox" :value="true" v-model="profiles.vet">
              <label><user-group-icon group="vet" /> Veterinários</label>
            </div>
          </div>
          <div class="field">
            <div class="ui checkbox user-picker-multiple-form-checkbox">
              <input type="checkbox" :value="true" v-model="profiles.financial">
              <label><user-group-icon group="financial" /> Financeiro</label>
            </div>
          </div>
          <div class="field">
            <div class="ui checkbox user-picker-multiple-form-checkbox m-l-10">
              <input type="checkbox" :value="true" v-model="profiles.admin">
              <label><user-group-icon group="admin" /> Administradores</label>
            </div>
          </div>
        </div>

        <div class="fields m-t-20">
          <div class="eight wide field">
            <label class="form-label">Grupos de Usuários</label>
            <select-dropdown ref="groupsDropdown" :multiple="true" @onAdd="onAddGroup" @onRemove="onRemoveGroup" />
          </div>
          <div class="eight wide field">
            <label class="form-label">Selecionar individualmente</label>
            <user-picker ref="userPicker" @onPick="onPickUser" />
          </div>
        </div>

        <table v-if="hasUsers" class="ui celled selectable tablet stackable table animated fadeIn m-t-30">
          <thead v-if="$isDesktop">
            <tr>
              <th>Nome</th>
              <th>Perfil</th>
              <th></th>
            </tr>  
          </thead>
          <tbody>
            <tr v-for="(user, index) in users">
              <td>
                <strong class="mobile-only">Nome: </strong> {{ user.name + ' ' + user.lastName }}                  
              </td>
              <td>
                <strong class="mobile-only">Perfil: </strong> 
                <user-group-icon :group="user.group" />
                {{ user.groupName }}         
                <span v-if="user.userGroupName" class="ui small label">{{ user.userGroupName }}</span>
              </td>
              <td style="width: 50px;">
                <button class="ui small icon button" @click="onRemoveUser(index)">
                  <i class="times icon"></i>
                </button>
              </td>                       
            </tr>                
          </tbody>
        </table>

        <p v-else class="grey text m-t-30 animated fadeIn">
          <i class="info circle icon"></i> Nenhum usuário selecionado
        </p>

      </div>            

    </div>

    <div class="actions">
      <button class="ui cancel basic button">
        <i class="times icon"></i> Cancelar
      </button>
      <button class="ui blue button" :class="{ disabled: !hasUsers }" @click="onConfirm()">
        <i class="check icon"></i> Confirmar
      </button>      
    </div>

  </div>

</template>

<script>

  import _ from "underscore"
  import modalDialog from "@/mixins/modal-dialog"
  import UserService from "@/services/user-service"
  import UserGroupService from "@/services/user-group-service"
  import { UserGroupIcon, UserPicker, SelectDropdown } from "@/components"

  export default {
    
    name: "UserPickerMultiple",

    mixins: [modalDialog],

    data() {
      return {        
        service: new UserService(),
        groupService: new UserGroupService(),
        users: [],
        profiles: {
          employee: false,
          customer: false,          
          vet: false,
          financial: false,
          admin: false,
        },
      }
    },

    components: {
      UserGroupIcon,
      UserPicker,
      SelectDropdown,
    },

    mounted() {
      
      $(".user-picker-multiple-form-checkbox").checkbox()

      this.loadGroups()
    },

    computed: {

      hasUsers() {
        return (this.users.length > 0)
      },
    },

    watch: {

      "profiles.employee" () {
        this.updateProfileUsers("employee")
      },

      "profiles.customer" () {
        this.updateProfileUsers("customer")
      },

      "profiles.vet" () {
        this.updateProfileUsers("vet")
      },

      "profiles.financial" () {
        this.updateProfileUsers("financial")
      },

      "profiles.admin" () {
        this.updateProfileUsers("admin")
      },
    },

    methods: { 
      
      onShow() {
        
        this.users = []

        this.profiles = {
          employee: false,
          customer: false,          
          vet: false,
          financial: false,
          admin: false,
        }

        this.$refs.groupsDropdown.reset()
      },   

      async loadGroups() {

        this.loading = true

        try {

          const groups = await this.groupService.findAll({
            attributes: ["id", "name"],
            order: ["name"],
          })

          this.$refs.groupsDropdown.setValues(groups)
          
        } catch (error) {
          
          this.$errorHandler(error)
        
        } finally {

          this.loading = false
        }
      },
      
      updateProfileUsers(profile) {

        if (this.profiles[profile]) {
          this.addProfileUsers(profile)
        } else {
          this.removeProfileUsers(profile)
        }
      },

      async addProfileUsers(profile) {
        
        this.loading = true

        try {

          const users = await this.service.getProfileUsers(profile)

          for (let user of users) {
            this.addUser(user)
          }

          this.sortUsers()
          
        } catch (error) {
          
          this.$errorHandler(error)
        
        } finally {

          this.loading = false
        }
      },

      removeProfileUsers(profile) {
        
        this.loading = true

        let newUsers = []

        for (let user of this.users) {
          if (user.group !== profile)
            newUsers.push(user)
        }

        this.users = newUsers.slice()

        this.sortUsers()

        this.loading = false
      },

      async onAddGroup(groupId) {
        
        this.loading = true

        try {

          const users = await this.service.findGroupUsers(groupId)

          for (let user of users) {
            this.addUser(user)
          }

          this.sortUsers()
          
        } catch (error) {
          
          this.$errorHandler(error)
        
        } finally {

          this.loading = false
        }
      },

      onRemoveGroup(groupId) {
        
        this.loading = true

        let newUsers = []

        for (let user of this.users) {
          if (user.userGroupId != groupId)
            newUsers.push(user)
        }

        this.users = newUsers.slice()

        this.sortUsers()

        this.loading = false
      },

      onPickUser(user) {              

        if (this.addUser(user)) {
          this.sortUsers()
        } else {
          this.$msg.info("Usuário já adicionado")
        }  

        this.$refs.userPicker.clear()
      },

      addUser(user) {

        let exists = false
        let added = false

        this.users.forEach((el) => {
          if (user.id == el.id)
            exists = true
        })

        if (!exists) {          
          this.users.push(this.$cloneObject(user))
          added = true
        }

        return added
      },

      onRemoveUser(index) {
        this.users.splice(index, 1)
        this.sortUsers()
      },

      sortUsers() {

        let sortedUsers = []

        for (let user of this.users) {
          user.fullName = user.name.trim().toLowerCase() + user.lastName.trim().toLowerCase()
          sortedUsers.push(user)
        }

        sortedUsers = _.sortBy(sortedUsers, "fullName")

        this.users = sortedUsers.slice()
      },

      onConfirm() {
        this.hide()
        this.$emit("onPickUsers", this.users.slice())
      },
    },
  }

</script>